import type { SVGProps } from 'react';
const SvgPay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Pay_svg__a)">
      <path
        d="M6.5 9.5A1.5 1.5 0 1 0 8 8a1.5 1.5 0 1 1 1.5-1.5M8 4v1m0 6v1M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Pay_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPay;
